import { noTenant } from 'apprise-core/tenant'
import { User, UserRef } from 'apprise-core/user'
import { usePreload } from 'apprise-frontend-core/client/preload'
import { useIAMService } from 'apprise-frontend-iam/service'
import { useIAMSettings } from 'apprise-frontend-iam/settings'
import { useNewUser } from './model'



export const userApi = "/user"
export const useRefApi = "/userrefs"
export const loggedApi = "/logged"



export const useUserCalls = () => {

    const newUser = useNewUser()
    
    const service = useIAMService()

    const preload = usePreload()


   const settings = useIAMSettings()
    
    const self = {

        // come with no permissions, so won't need to be interned.
        fetchAll: ()=>(
            
                preload.get<User[]>(userApi) ?? service.at(`${userApi}?permissions=true`).get<User[]>()
            
        )
        

        ,

        fetchReferences: () => (preload.get<UserRef[]>(useRefApi) ??  service.at(settings.retrieveAllUserReferences ? `${useRefApi}/all` : useRefApi).get<UserRef[]>()).then(users => users.map(({ username, name }) => {

            const base = newUser(noTenant);

            base.lifecycle.state = 'active'
            base.username = username
         
            const [firstName, ...lastnames] = name.split(' ')

            base.details.firstname = firstName
            base.details.lastname = lastnames.join(' ')

            return base

        }))

        ,

        fetchOne: (username: string) =>  service.at(`${userApi}/${username}`).get<User>()

        ,

        add: (user:User) =>  service.at(userApi).post<User>(user)
    
        ,
    
        update: (user:User) => service.at(`${userApi}/${user.username}`).put<User>(user)
    
        , 

        updateMany: (many: User[]) => service.at(`${userApi}/bulk`).put<User[]>(many)
        ,

        delete: (username:string) => service.at(`${userApi}/${username}`).delete()

        ,

        updateProfile: (user:User) => service.at(`${userApi}/${user.username}/profile`).put<User>(user)
    }

    return self;

}
